var chunkMapping = {
	"webpack_container_remote_gtm": [
		"webpack/container/remote/gtm"
	],
	"webpack_container_remote_fanar": [
		"webpack/container/remote/fanar"
	],
	"webpack_container_remote_mobileAssets": [
		"webpack/container/remote/mobileAssets"
	],
	"webpack_container_remote_vaiaApp": [
		"webpack/container/remote/vaiaApp"
	],
	"webpack_container_remote_supplychain": [
		"webpack/container/remote/supplychain"
	],
	"webpack_container_remote_neon": [
		"webpack/container/remote/neon"
	],
	"webpack_container_remote_aiAssistant": [
		"webpack/container/remote/aiAssistant"
	],
	"webpack_container_remote_cam": [
		"webpack/container/remote/cam"
	],
	"webpack_container_remote_dma": [
		"webpack/container/remote/dma"
	],
	"webpack_container_remote_irisApp": [
		"webpack/container/remote/irisApp"
	],
	"webpack_container_remote_graphExplorer": [
		"webpack/container/remote/graphExplorer"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/gtm": [
		"default",
		".",
		"webpack/container/reference/gtm"
	],
	"webpack/container/remote/fanar": [
		"default",
		".",
		"webpack/container/reference/fanar"
	],
	"webpack/container/remote/mobileAssets": [
		"default",
		".",
		"webpack/container/reference/mobileAssets"
	],
	"webpack/container/remote/vaiaApp": [
		"default",
		".",
		"webpack/container/reference/vaiaApp"
	],
	"webpack/container/remote/supplychain": [
		"default",
		".",
		"webpack/container/reference/supplychain"
	],
	"webpack/container/remote/neon": [
		"default",
		".",
		"webpack/container/reference/neon"
	],
	"webpack/container/remote/aiAssistant": [
		"default",
		".",
		"webpack/container/reference/aiAssistant"
	],
	"webpack/container/remote/cam": [
		"default",
		".",
		"webpack/container/reference/cam"
	],
	"webpack/container/remote/dma": [
		"default",
		".",
		"webpack/container/reference/dma"
	],
	"webpack/container/remote/irisApp": [
		"default",
		".",
		"webpack/container/reference/irisApp"
	],
	"webpack/container/remote/graphExplorer": [
		"default",
		".",
		"webpack/container/reference/graphExplorer"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}